<template>
  <span v-if="value">
    {{displayDate}}<br v-if="split"><span v-if="!split && showTime">, </span>
    <span v-if="showTime">{{displayTime}}</span>
  </span>
  <span v-else>
    --
  </span>
</template>

<script>
import mergeService from '../../services/orderMerge'

export default {
  props: {
    value: { type: [String, Number, Object], default: '' },
    showTime: { type: Boolean, default: true },
    split: { type: Boolean, default: false },
    merge: { type: Boolean, default: false },
    isUtc: { type: Boolean, default: false }
  },
  computed: {
    cleaned() {
      if (!this.value) return '';

      const val = this.merge ? mergeService.mergeField(this.value) : this.value;

      let d = parseFloat(val) > 10000000 ? parseFloat(val) * 1000 : Date.parse(val)
      if (this.isUtc) {
        // daylight savings time.... we meet again...
        if (new Date(d).getTimezoneOffset() != new Date().getTimezoneOffset()) {
          let offsetDifferenceMinutes = new Date(d).getTimezoneOffset() - new Date().getTimezoneOffset()
          d += offsetDifferenceMinutes * 60*1000;
        }
        d = d + (new Date()).getTimezoneOffset()/60*3600000

      }
      return new Date(d)
    },
    displayDate() {
      if (!this.cleaned) { return this.value; }
      return this.cleaned.toLocaleDateString('en-us', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    },
    displayTime() {
      if (!this.cleaned || !this.showTime) { return ''; }
      return this.cleaned.toLocaleTimeString('en-US')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utility/NiceDate.vue